import { compose, lensPath, set, view } from 'ramda'
import { isTrue } from 'ramda-adjunct'
import pipe from 'ramda/src/pipe'
import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import UserContext from '../../../context/UserContext'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'
import HubBuyTherapyGrantPage from './HubBuyTherapyGrantPage'
import getEnvironment from '../../../config/getEnvironment'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `hub-buy-therapy-grant`
const { HOST } = getEnvironment()
// TODO: Get base checkout URL from routing query
const BASE_CHECKOUT_URL = `${HOST.APP}/checkout`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const canAccessProgrammeLens = lensPath([`canAccessProgramme`])

const getCanAccessProgrammeLens = view(canAccessProgrammeLens)

const getEnrolmentCanAccessProgramme = pipe(getCanAccessProgrammeLens, isTrue)

const setPagesHubSleepImrovementPlanCardLinkUrl = set(
  lensPath([`page`, `content`, `ctaButton`, `url`])
)

const setPagesHubSleepImrovementPlanCardSecondaryLinkUrl = set(
  compose(lensPath([`page`, `content`, `ctaButtonSecondary`, `url`]))
)

const injectRouting = (content, route) =>
  pipe(
    setPagesHubSleepImrovementPlanCardLinkUrl(route),
    setPagesHubSleepImrovementPlanCardSecondaryLinkUrl(route)
  )(content)

const buildCheckoutUrl = (currency, productKey) =>
  `${BASE_CHECKOUT_URL}?currency=${currency.code}&key=${productKey}&discount_code=GRANT759&flow=nhs-sp`

const getRouteBasedOnEnrolmentState = (
  currency,
  canEnrolmentAccessProgramme,
  routing,
  product
) =>
  canEnrolmentAccessProgramme
    ? routing.assessmentPath
    : buildCheckoutUrl(currency, product.key)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubBuyTherapyGrantModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const { currentEnrolment } = useContext(UserContext)
  const canEnrolmentAccessProgramme =
    getEnrolmentCanAccessProgramme(currentEnrolment)
  const { upgradeProducts } = currentEnrolment
  const product = upgradeProducts[0]
  const productPrice = product.prices[0]
  const { appRouting } = useContext(RoutingContext)
  const route = getRouteBasedOnEnrolmentState(
    productPrice.currency,
    canEnrolmentAccessProgramme,
    appRouting,
    product
  )
  const loaderDataWithRouting = injectRouting(loaderData, route)

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  return (
    <HubBuyTherapyGrantPage
      content={loaderDataWithRouting.page.content}
      canEnrolmentAccessProgramme={canEnrolmentAccessProgramme}
    />
  )
}

export default HubBuyTherapyGrantModule
